<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptitle"><a id="note"></a>Author's Note</h1>
<p class="text"><a id="page_ix"></a>Use this book as your guide and inspiration. Have a notebook or journal dedicated to the exercises you choose to do from this book. Take the book at your own pace—spend as much or as little time as you want to spend with any one topic. You can either go through from start to finish or skip around as topics appeal to your needs and interests.</p>
<p class="textindent">Explore fear and love, resistance and acceptance, willpower and discernment. Bring peace into your daily life. This is a book to return to again and again. Savor each of the seventy-five essays and the practices that follow it. Choose the ones that speak to you and discard the rest.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_authornotes.vue?f3207f64